/** @prettier */

import Box from '@mui/material/Box';

//interface import
import * as apiIF from '../Type/api';
//Style import
import '../css/common/colors.css';

/**
 * ログイン後のフッター
 * @returns JSX
 */
const Footer = (props: {
  footerText: apiIF.res.getSettingUser['footer-text'];
}) => {
  return (
    <footer>
      <Box component="span" className="text">
        {props.footerText}
      </Box>
    </footer>
  );
};
export default Footer;
